import { Component } from '@angular/core';
import { Title } from '@node_modules/@angular/platform-browser';
import { PwaInstallService } from '@shared/service-proxies/EventEmitterService';
import { AuthService } from 'services/auth.service';

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet>`
})
export class RootComponent {

    constructor(private readonly _authService: AuthService, public pwa: PwaInstallService, private readonly title: Title) {
        this._authService.startPolling();
    }
}
